import { Injectable } from '@angular/core';
import { BehaviorSubject, asyncScheduler } from 'rxjs';
import { distinctUntilChanged, observeOn } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private pendingLoadings = 0;
  private showLoadingSource = new BehaviorSubject<boolean>(false);
  readonly showLoading$ = this.showLoadingSource.asObservable().pipe(observeOn(asyncScheduler), distinctUntilChanged());

  constructor() {}

  show() {
    this.pendingLoadings++;
    this.showLoadingSource.next(true);

  }

  hide() {
    this.pendingLoadings--;

    if (this.pendingLoadings <= 0) {
      this.showLoadingSource.next(false);
      this.pendingLoadings = 0;
    }
  }
}
